(ns frontend.view.settings2.surveys.survey-blocks-tab
    (:require
      [common.localization :as loc]
      [frontend.ux-overhaul.table.helpers :as table-helpers]
      [frontend.ux-overhaul.table.view :as table]
      [frontend.view.modals.delete-confirmation.check-usage-view :as delete-confirmation-check-usage]
      [frontend.view.modals.entity-editor.view :as entity-editor]
      [frontend.view.modals.events :as modals]
      [frontend.view.settings2.surveys.events :as events]
      [oops.core :as oops]
      [re-frame.core :as rf]
      [reagent.core :as r]
      [ui.components.button.view :as button]))

(def survey-block-columns
  [{:headerName (loc/tr :survey-block-label)
    :sort       "asc"
    :field      :survey-block/label}
   {:headerName   (loc/tr :survey-block/languages)
    :field        :survey-block/languages
    :cellRenderer (fn [props]
                    (table-helpers/multi-string-renderer (table/get-cell-value props)))}
   ;; One action column rather than three 60px columns with empty headers.
   ;; Each button says what it does, as a tooltip and again as an accessible
   ;; name - three unlabelled icons is bad enough on a survey type row, and one
   ;; of these deletes.
   {:colId                     "actions"
    :headerName                (loc/tr :settings.surveys/actions-column)
    :resizable                 false
    :width                     140
    :sortable                  false
    :suppressHeaderMenuButton  true
    :suppressHeaderContextMenu true
    :cellRenderer
    (fn [props]
      (r/as-element
       [:div
        {:class "h-full flex items-center gap-2"}
        [button/square-secondary-open
         {:tooltip    (loc/tr :settings.surveys/edit-block-content)
          :aria-label (loc/tr :settings.surveys/edit-block-content)
          :on-click
          #(rf/dispatch [::events/start-edit-survey-block (table-helpers/get-row-data-id props)])}
         [:i.fal.fa-cog]]
        [button/square-secondary-open
         {:tooltip    (loc/tr :settings.surveys/edit-block-settings)
          :aria-label (loc/tr :settings.surveys/edit-block-settings)
          :on-click
          #(modals/open-modal! entity-editor/modal-key
                               {:entity-id (table-helpers/get-row-data-id props)})}
         [:i.fas.fa-pen]]
        [button/square-secondary-open
         {:tooltip    (loc/tr :settings.surveys/delete-block)
          :aria-label (loc/tr :settings.surveys/delete-block)
          :on-click
          (fn []
            (let [entity-id (table-helpers/get-row-data-id props)]
              (modals/open-modal! delete-confirmation-check-usage/modal-key
                                  {:body         (loc/tr :delete-confirmation-body-text
                                                         [(loc/tr :entity.type/survey-block)
                                                          (get-in (js->clj props :keywordize-keys true)
                                                                  [:data :label])])
                                   :body-caution (loc/tr :survey-block-delete-caution)
                                   :entity-id    entity-id})))}
         [:i.fas.fa-trash-alt]]]))}])

(defn selection-changed
  [state params-js]
  (let [grid-api (oops/oget params-js "api")
        selected-nodes-js (oops/ocall grid-api "getSelectedNodes")
        selected-nodes (js->clj selected-nodes-js :keywordize-keys true)
        selected-ids (->> selected-nodes
                          (map (fn [selected-node]
                                 (js->clj (oops/oget selected-node "data") {:keywordize-keys true})))
                          (map :id)
                          (set))]
    (swap! state assoc :selected-ids selected-ids)))

(defn mass-tools
  [state]
  (let [selected-ids (:selected-ids @state)]
    (when (seq selected-ids)
      [:div
       {:class "px-3 py-2 flex gap-3 text-base-light-text border border-solid border-base-light-border-paler bg-base-light rounded"}
       [:div
        {:class-name "overflow-visible z-[1] flex items-center gap-3"}
        ;; Clone only. A mass delete was started and abandoned: the event it
        ;; called sent :entity/clone-entities, and its :on-success and
        ;; :on-error handlers were never written, so the button was commented
        ;; out rather than finished. Both it and the event are removed; rows
        ;; are deleted one at a time from the action column, which works.
        [button/helper-button
         {:on-click (fn [_]
                      (rf/dispatch [::events/clone-blocks selected-ids]))}
         [:i.fal.fa-clone]
         (loc/tr :clone)]]])))

(defn survey-blocks-table
  [state survey-blocks]
  [:div
   {:class "py-6 flex flex-col gap-4"}
   [:div
    [table/view
     {:grid-id                    "survey-blocks-table"
      :state-atom                 state
      :column-defs                survey-block-columns
      :row-data                   survey-blocks
      :default-col-def            {:sortable  true
                                   :resizable true
                                   :editable  false
                                   :menuTabs  ["generalMenuTab"]}
      :row-selection              {:mode "multiRow"}
      :min-height                 "300px"
      :auto-height?               true
      :enable-cell-text-selection false
      :on-selection-changed       (partial selection-changed state)
      :width                      "100%"
      :tools                      [mass-tools state]}]]])

(defn view
  [state survey-blocks]
  [survey-blocks-table state survey-blocks])
